import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import TextButton from 'components/TextButton';
import ModalCloseIcon from 'resources/icon-close-white.svg';
import {
  getCategoryItemClassName,
  getModalBodyBackgroundClass
} from '../WStoreUtils';
import './WStoreAlert.css';

function WStoreAlert({ selectedItem, alertMsg, onClose }) {
  return (
    <Modal
      className="modal-dialog-wstore-alert"
      show={!!alertMsg}
      onHide={onClose}
    >
      <Modal.Body
        bsPrefix={`${getModalBodyBackgroundClass(
          selectedItem
        )} ${getCategoryItemClassName(selectedItem?.classCode)}`}
      >
        <TextButton className="btn-close" onClick={onClose}>
          <img src={ModalCloseIcon} alt="Close alert" />
        </TextButton>
        <div className="title">Sorry!</div>
        <div className="title-text">Unable to purchase</div>
        <div className="msg">{alertMsg}</div>
      </Modal.Body>
    </Modal>
  );
}

WStoreAlert.propTypes = {
  selectedItem: PropTypes.object,
  alertMsg: PropTypes.string,
  onClose: PropTypes.func
};

export default WStoreAlert;
